"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
var UserStatus;
(function (UserStatus) {
    UserStatus["LoogedIn"] = "LOGGEDIN";
    UserStatus["LoogedOut"] = "LOGGEDOUT";
    UserStatus["Away"] = "AWAY";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
var WebPushEvent;
(function (WebPushEvent) {
    WebPushEvent["Chat"] = "CHAT";
    // Only the orders that I have created
    WebPushEvent["OrderStatus"] = "ORDER_STATUS";
    // All retailer orders, must be admin
    WebPushEvent["OrderStatusAll"] = "ORDER_STATUS_ALL";
})(WebPushEvent = exports.WebPushEvent || (exports.WebPushEvent = {}));
class User extends Parse.User {
    constructor(attributes) {
        super(attributes);
    }
    get email() {
        return this.getEmail() || '';
    }
    set email(value) {
        this.setEmail(value);
    }
    get name() {
        return this.get('name');
    }
    set name(value) {
        this.set('name', value);
    }
    get disabled() {
        return this.get('disabled');
    }
    set disabled(value) {
        this.set('disabled', value);
    }
    get lastName() {
        return this.get('lastName');
    }
    set lastName(value) {
        this.set('lastName', value);
    }
    get username() {
        return this.get('username');
    }
    set username(value) {
        this.set('username', value);
    }
    get retailer() {
        return this.get('retailer');
    }
    set retailer(value) {
        this.set('retailer', value);
    }
    /* This user is only for API access */
    get apiUser() {
        return this.get('apiUser');
    }
    set apiUser(value) {
        this.set('apiUser', value);
    }
    /* This user is only for API access */
    get botUser() {
        return this.get('botUser');
    }
    set botUser(value) {
        this.set('botUser', value);
    }
    /*
     * Used with our whatsapp button. Nothing to do with the whatsapp integration
     */
    get whatsAppNumber() {
        return this.get('whatsAppNumber');
    }
    set whatsAppNumber(value) {
        this.set('whatsAppNumber', value);
    }
    /*
     * If set this will be the whatsapp used to create new chats.
     * Only works with a retailer that has more than 1x whatsapp associated with
     */
    get whatsapp() {
        return this.get('whatsapp');
    }
    set whatsapp(value) {
        this.set('whatsapp', value);
    }
    get status() {
        return this.get('status');
    }
    set status(value) {
        this.set('status', value);
    }
    get pricingTable() {
        return this.get('pricingTable');
    }
    set pricingTable(value) {
        this.set('pricingTable', value);
    }
    get webPushEndpoint() {
        return this.get('webPushEndpoint');
    }
    set webPushEndpoint(value) {
        this.set('webPushEndpoint', value);
    }
    get webPushEvents() {
        return this.get('webPushEvents');
    }
    set webPushEvents(value) {
        this.set('webPushEvents', value);
    }
    get supportSequence() {
        return this.get('supportSequence');
    }
    set supportSequence(value) {
        this.set('supportSequence', value);
    }
    get customerBaseSegPreferences() {
        return this.get('customerBaseSegPreferences');
    }
    set customerBaseSegPreferences(value) {
        this.set('customerBaseSegPreferences', value);
    }
    get preferences() {
        return this.get('preferences');
    }
    set preferences(value) {
        this.set('preferences', value);
    }
    get sessionsPolicy() { return this.get('sessionsPolicy'); }
    set sessionsPolicy(value) { this.set('sessionsPolicy', value); }
    get lastLoginData() { return this.get('lastLoginData'); }
    set lastLoginData(value) { this.set('lastLoginData', value); }
    // Whether this user is a internal OmniChat support user to enable us to login on the user account.
    get supportUser() { return this.get('supportUser'); }
    set supportUser(value) { this.set('supportUser', value); }
    get timeAccessRestriction() { return this.get('timeAccessRestriction'); }
    set timeAccessRestriction(value) { this.set('timeAccessRestriction', value); }
    get totalActiveChats() { return this.get('totalActiveChats'); }
    set totalActiveChats(value) { this.set('totalActiveChats', value); }
}
exports.User = User;
Parse.Object.registerSubclass('User', User);
//# sourceMappingURL=User.js.map